import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import qs from 'qs';

import {
  Typography,
  Box,
} from '@material-ui/core';

import TopSection from '../common/topSection';
import Loading from '../common/loading';
import Alert from '../common/alert';
import ItemsList from './itemsList';

import { clearSaveStatus, selectSaveStatus } from '../itemSearches/itemSearchesSlice';
import { enqueueSnackbar } from '../snackbar/snackbarSlice';


import { fetchItems, selectItems } from './treadItemsSlice';



const TreadItemsPage = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { items, status: itemsStatus, error: itemsError } = useSelector(selectItems);
  const { status: itemSearchStatus, error: itemSearchError } = useSelector(selectSaveStatus);

  const itemsWithRouterLinks = items.map(item => ({
    ...item,
    link: `/pih/owner/${item.itemOwnerId}/tread-item/${item.itemCode}`
  }));



  useEffect(() => {
    // Check once on load if query param should autosearch
    if(location.search) {
      const queryParams = qs.parse(location.search.replace('?', ''));

      if(queryParams.itemFamilyCode) {
        // Autopopulate familycode to filters
        const search = {
          activeOperator: 'AND',
          activeFilters: [
            {
              type: 'multiChoice',
              operation: 'oneOf',
              field: 'itemFamilyCode',
              value: [queryParams.itemFamilyCode],
              id: 'search-row-default'
            }
          ],
        };

        // Search immediately
        dispatch(fetchItems(search));
      }
    }
  }, []);

  useEffect(() => {
    // Show save feedback
    if(itemSearchStatus === 'failed') {
      dispatch(enqueueSnackbar({
        message: t(`errors:${itemSearchError}`),
        options: {
          variant: 'error'
        }
      }));
      dispatch(clearSaveStatus());
    } else if(itemSearchStatus === 'succeeded') {
      dispatch(enqueueSnackbar({
        message: t('itemSearch:searchSavedSuccessfully'),
        options: {
          variant: 'success'
        }
      }));
      dispatch(clearSaveStatus());
    }
  }, [itemSearchStatus]);

  return (
    <>
      <TopSection>
        <Typography variant="h4" component="h1">{t('item:treadItems')}</Typography>
      </TopSection>

      <Box p={3}>
        {itemsStatus === 'succeeded' ? <ItemsList items={itemsWithRouterLinks} showNoResultsMessage /> : null}
        {itemsStatus === 'loading' ? <Loading message={t('itemSearch:loadingResults')}/> : null}
        {itemsStatus === 'failed' && itemsError ? <Alert severity="error">{t(`errors:${itemsError.message}`)}</Alert> : null}
      </Box>
    </>
  )
};

export default TreadItemsPage;
